import React from "react";

export const CaseStamp = ({ children, tone = "red", rotate = -8, className = "" }) => (
  <span
    className={`case-stamp case-stamp--${tone} ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    {children}
  </span>
);

export default CaseStamp;
